/* eslint-disable @typescript-eslint/no-explicit-any */
import { envConfig } from '../../../../utils/config';
import { AuthModel } from './_models'

const AUTH_COOKIE_KEY = 'app_data'
const PUBLIC_DOMAIN = new URL(envConfig.APP_PUBLIC_URL).hostname;

const getAuth = (): AuthModel | undefined => {
  if (typeof document === 'undefined') return

  const cookieValue = window.CookieUtils.getCookie(AUTH_COOKIE_KEY, { secret_level: 'secure', secret: envConfig.APP_API_SECRET });

  if (!cookieValue) return

  try {
    const auth: AuthModel = JSON.parse(cookieValue);
    return auth
  } catch (error) {
    console.error('AUTH COOKIE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (typeof window === "undefined") return;

  try {
    const PUBLIC_DOMAIN = new URL(envConfig.APP_PUBLIC_URL).hostname;
    const cookieValue = JSON.stringify(auth);
    CookieUtils.setCookie(AUTH_COOKIE_KEY, cookieValue, PUBLIC_DOMAIN, {
      secret_level: 'secure',
      secret: envConfig.APP_API_SECRET,
      days: 1,
      sameSite: "Lax",
      secure: true,
    })
  } catch (error) {
    console.error("AUTH COOKIE SAVE ERROR", error);
  }
};

const removeAuth = () => {
  if (typeof document === 'undefined') return
  try {
    console.log("deleteCookie")
    window.CookieUtils.deleteCookie(AUTH_COOKIE_KEY, PUBLIC_DOMAIN)
  } catch (error) {
    console.error('AUTH COOKIE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: { headers: { Authorization?: string } }) => {
      //const auth = getAuth()
      /*if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
      }*/

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

const AUTH_PATH_PREFIX = '/auth'
const DEFAULT_POST_LOGIN_PATH = '/pages/home'

type LoginRedirectState = {
  from?: {
    pathname?: string
    search?: string
    hash?: string
  }
}

/**
 * Allow only in-app paths so login cannot be used as an open redirect.
 */
const getSafeRedirectPath = (path: string | null | undefined): string | null => {
  if (!path) {
    return null
  }

  let decoded = path
  try {
    decoded = decodeURIComponent(path)
  } catch {
    return null
  }

  if (!decoded.startsWith('/') || decoded.startsWith('//')) {
    return null
  }

  const pathname = decoded.split(/[?#]/)[0]
  if (pathname === AUTH_PATH_PREFIX || pathname.startsWith(`${AUTH_PATH_PREFIX}/`)) {
    return null
  }

  return decoded
}

const resolvePostLoginPath = (
  search: string,
  state: LoginRedirectState | null | undefined,
  fallback: string = DEFAULT_POST_LOGIN_PATH
): string => {
  const params = new URLSearchParams(search)
  const fromPath = state?.from
    ? `${state.from.pathname ?? ''}${state.from.search ?? ''}${state.from.hash ?? ''}`
    : null

  return getSafeRedirectPath(params.get('redirect')) ?? getSafeRedirectPath(fromPath) ?? fallback
}

export { getAuth, setAuth, removeAuth, AUTH_COOKIE_KEY, getSafeRedirectPath, resolvePostLoginPath }